var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVector5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 58,
    viewBox: "0 0 64 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_310_1303)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.4026 37.9899C55.4959 41.1411 53.4219 43.028 51.2576 41.7562C50.3779 41.2381 50.042 40.6578 48.8383 37.4889C43.7281 24.0899 41.103 18.9671 35.3464 11.1497C33.1865 8.22101 32.8664 7.09724 34.3632 7.72472C36.0441 8.42718 40.8482 12.4152 43.5334 15.3273C50.3513 22.7345 55.2347 32.0588 55.4026 37.9899Z",
    fill: "#0071BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.59494 38.9512C3.90431 40.5958 1.2148 39.7575 1.22212 37.2593C1.22573 36.2408 1.56565 35.6697 3.70371 33.0549C12.7634 21.9866 15.8799 17.1894 19.7511 8.34474C21.1989 5.03196 22.0113 4.20098 22.2283 5.79721C22.4723 7.59067 21.4462 13.7095 20.2717 17.4706C17.295 27.0167 11.6652 35.8546 6.59494 38.9512Z",
    fill: "#FFC41E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1453 44.6889C24.2396 47.1943 21.4313 47.3719 20.5287 45.0441C20.1635 44.097 20.2702 43.4398 21.3061 40.2164C25.701 26.6182 26.8605 21.0061 27.2479 11.3631C27.3913 7.74072 27.8436 6.67436 28.625 8.09246C29.4979 9.68091 30.7726 15.7702 31.0506 19.6973C31.7555 29.6876 29.7392 39.9709 26.1453 44.6889Z",
    fill: "#00BF9F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_310_1303"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41.4565,
    height: 51.1729,
    fill: "white",
    transform: "matrix(0.377254 -0.92611 -0.92611 -0.377254 47.8179 57.9697)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector5);
export default __webpack_public_path__ + "static/media/vector-5.0fb45cb27763119e15fd4f431cab310c.svg";
export { ForwardRef as ReactComponent };